import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { layout: "default" },
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    meta: { layout: "page" },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/About.vue"),
  },
  {
    path: "/rpcpool",
    name: "RPC Pool",
    meta: { layout: "page" },

    component: () => import("../views/RPCPool.vue"),
  },
  {
    path: "/blog",
    name: "Blog",
    meta: { layout: "page" },

    component: () => import("../views/Blog.vue"),
  },
  {
    path: "/projects",
    name: "Ecosystem Projects",
    meta: { layout: "page" },

    component: () => import("../views/Projects.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    meta: { layout: "page" },

    component: () => import("../views/Pricing.vue"),
  },
  {
    path: "/pricing/paid-pricing",
    name: "Paid pricing",
    meta: { layout: "page" },

    component: () => import("../views/Paid-pricing.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    meta: { layout: "page" },

    component: () => import("../views/Contact.vue"),
  },
  {
    path: "/professional-trading-centers",
    name: "Professional Trading Centers",
    meta: { layout: "page" },

    component: () => import("../views/ProTradingCenters.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
